import { render, staticRenderFns } from "./LayoutH5.vue?vue&type=template&id=aba91ff4&scoped=true&"
import script from "./LayoutH5.vue?vue&type=script&lang=js&"
export * from "./LayoutH5.vue?vue&type=script&lang=js&"
import style0 from "./LayoutH5.vue?vue&type=style&index=0&id=aba91ff4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba91ff4",
  null
  
)

export default component.exports